import actionTypes from '../constants/action-types';

export default (pageId, htmlCheckpoint) => ({
  type: actionTypes.SET_HTML_CHECKPOINT,
  payload: {
    pageId,
    htmlCheckpoint,
  },
});
